(function() {
    angular
        .module("app")
        .factory("deviceGroupsService", deviceGroupsService)

    deviceGroupsService.$inject = ["$rootScope", "$state", "$http", "queryStringService"]

    function deviceGroupsService($rootScope, $state, $http, queryStringService) {
        var service = {}

        /**
            Get all device groups
            @returns {*}
         **/
        service.getDeviceGroups = function() {
            var extractCustomerID = queryStringService.extractCustomerID($rootScope.selectedCustomerID)
            return $http({
                method: "GET",
                url: $rootScope.config.apiUrl + "/device_groups?"
                    + extractCustomerID
            }).then(getDeviceGroupsComplete, getDeviceGroupsFailed)

            function getDeviceGroupsComplete(response) {
                return response.data
            }

            function getDeviceGroupsFailed(error) {
                console.error(error)
            }
        }

        /**
            Create new device group
            @param {string} deviceGroupName
            @param successCallback
            @param failureCallback
            @returns {*}
         **/
        service.createDeviceGroup = function(deviceGroupName, successCallback, failureCallback) {
            var extractCustomerID = queryStringService.extractCustomerID($rootScope.selectedCustomerID)
            return $http({
                method: "POST",
                url: $rootScope.config.apiUrl + "/device_groups/"
                    + "?device_group[name]=" + deviceGroupName
                    + extractCustomerID
            }).then(createDeviceGroupComplete, createDeviceGroupFailed)

            function createDeviceGroupComplete(response) {

                successCallback(response)
            }

            function createDeviceGroupFailed(error) {
                failureCallback(error)
                console.error(error)
            }
        }

        /**
            Edit existing device group
            @param {int} deviceGroupID
            @param deviceGroupName
            @param successCallback
            @param failureCallback
            @returns {*}
         **/
        service.editDeviceGroup = function(deviceGroupID, deviceGroupName, successCallback, failureCallback) {
            return $http({
                method: "PUT",
                url: $rootScope.config.apiUrl + "/device_groups/" + deviceGroupID + "?device_group[name]=" + deviceGroupName
            }).then(editDeviceGroupComplete, editDeviceGroupFailed)

            function editDeviceGroupComplete(response) {
                successCallback(response)
            }

            function editDeviceGroupFailed(error) {
                console.error(error)
                failureCallback(error)
            }
        }

        /**
            Delete existing device group
            @param {int} deviceGroupID
            @param successCallback
            @param failureCallback
            @returns {*}
         **/
        service.deleteDeviceGroup = function(deviceGroupID, successCallback, failureCallback) {
            return $http({
                method: "DELETE",
                url: $rootScope.config.apiUrl + "/device_groups/" + deviceGroupID
            }).then(deleteDeviceGroupComplete, deleteDeviceGroupFailed)

            function deleteDeviceGroupComplete(response) {
                successCallback(response)
            }

            function deleteDeviceGroupFailed(error) {
                console.error(error)
                failureCallback(error)
            }
        }

        /**
            Move device to device group
            @param {int} deviceGroupID
            @param deviceIDs
            @param successCallback
            @param failureCallback
            @returns {*}
         **/
        service.moveToDeviceGroup = function(deviceGroupID, deviceIDs, successCallback, failureCallback) {
            return $http({
                method: "PUT",
                url: $rootScope.config.apiUrl + "/device_groups/" + deviceGroupID,
                data: {
                    "device_group": {
                        "add_device_ids": deviceIDs
                    }
                }
            }).then(moveToDeviceGroupComplete, moveToDeviceGroupFailed)

            function moveToDeviceGroupComplete(response) {
                successCallback(response)
            }

            function moveToDeviceGroupFailed(error) {
                failureCallback(error)
                console.error(error)
            }
        }

        /**
            Remove device from device group
            @param deviceIDs
            @param successCallback
            @param failureCallback
            @returns {*}
         **/
        service.removeFromDeviceGroup = function(deviceIDs, successCallback, failureCallback) {
            return $http({
                method: "DELETE",
                url: $rootScope.config.apiUrl + "/device_groups_devices",
                headers: {
                    "Content-Type": "application/json"
                },
                data: {
                    "device_groups_devices": {
                        "device_ids": deviceIDs
                    }
                }
            }).then(removeFromDeviceGroupComplete, removeFromDeviceGroupFailed)

            function removeFromDeviceGroupComplete(response) {
                successCallback(response)
            }

            function removeFromDeviceGroupFailed(error) {
                failureCallback(error)
                console.error(error)
            }
        }

        /**
            Parse device groups
            @param deviceIDs
            @returns {string}
         **/
        service.parseDevices = function(deviceIDs) {
            var query = ""

            for (const deviceID of deviceIDs) {
                if (deviceID) {
                    query += "add_device_ids[]=" + deviceID + "&"
                }
            }

            return query
        }

        return service
    }
})()
